import { combineReducers } from "redux";
import asyncDataReducer from "./slices/asyncData";
import initOptions from "./slices/initOptions";
import user from "./slices/user";

const rootReducer = combineReducers({ asyncDataReducer, initOptions,user });
export default rootReducer;
